// Generated by `bun run themes:build` from packages/core/themes/*.json. Do not edit.
import type { ResolvedTheme } from "./themes";

export const BUILT_IN_THEMES: readonly ResolvedTheme[] = [
  {
    "id": "rivets-dark",
    "name": "Rivets Dark",
    "family": "Rivets",
    "author": "Frontier",
    "appearance": "dark",
    "colors": {
      "surface-1": "#121413",
      "surface-0": "#0c0d0c",
      "sidebar-surface": "#121413",
      "text-primary": "#f0f2f5",
      "text-secondary": "#a6adb8",
      "text-tertiary": "#7d8693",
      "surface-2": "#191b1a",
      "surface-3": "#222524",
      "border-subtle": "#e0e5ed0f",
      "border-strong": "#e0e5ed1f",
      "accent": "#8ab4f8",
      "accent-hover": "#a8c7fa",
      "on-accent": "#08111f",
      "accent-soft": "#8ab4f81a",
      "focus-ring": "#8ab4f84d",
      "success": "#3ccb8e",
      "success-soft": "#3ccb8e1f",
      "warning": "#f2b84b",
      "warning-soft": "#f2b84b1f",
      "danger": "#f06a72",
      "danger-soft": "#f06a721f",
      "primary-fill": "#f0f2f5",
      "primary-label": "#151716",
      "glass-fill": "#121413c7",
      "glass-border": "#e0e5ed1a",
      "find-match": "#f2b84b47",
      "find-match-current": "#f2b84b99",
      "accent-soft-solid": "#1f2531",
      "success-soft-solid": "#152824",
      "warning-soft-solid": "#2b261c",
      "danger-soft-solid": "#2b1d21",
      "on-cta": "#121413",
      "glass-tint": "#121413c7"
    },
    "syntax": {
      "keyword": "#c678dd",
      "string": "#98c379",
      "number": "#d19a66",
      "comment": "#7d8693",
      "variable": "#f0f2f5",
      "property": "#f0f2f5",
      "function": "#61afef",
      "type": "#61afef",
      "tag": "#e06c75",
      "heading": "#e06c75",
      "punctuation": "#a6adb8",
      "operator": "#a6adb8",
      "link": "#8ab4f8"
    },
    "ansi": [
      "#191b1a",
      "#f06a72",
      "#3ccb8e",
      "#f2b84b",
      "#8ab4f8",
      "#c99bf0",
      "#5cc8d2",
      "#a6adb8",
      "#7d8693",
      "#ff8c93",
      "#6fddab",
      "#f7cd7a",
      "#a8c7fa",
      "#ddb8f7",
      "#8ad9e0",
      "#f0f2f5"
    ]
  },
  {
    "id": "rivets-light",
    "name": "Rivets Light",
    "family": "Rivets",
    "author": "Frontier",
    "appearance": "light",
    "colors": {
      "surface-1": "#ffffff",
      "surface-0": "#f5f6f8",
      "sidebar-surface": "#eff1f4",
      "text-primary": "#171a1f",
      "text-secondary": "#555e6b",
      "text-tertiary": "#5f6976",
      "surface-2": "#eceff3",
      "surface-3": "#e1e5ea",
      "border-subtle": "#17202a0f",
      "border-strong": "#17202a1f",
      "accent": "#2f66c5",
      "accent-hover": "#2556aa",
      "on-accent": "#ffffff",
      "accent-soft": "#2f66c514",
      "focus-ring": "#2f66c54d",
      "success": "#137a55",
      "success-soft": "#137a551a",
      "warning": "#9a650d",
      "warning-soft": "#9a650d1a",
      "danger": "#b93845",
      "danger-soft": "#b938451a",
      "primary-fill": "#171a1f",
      "primary-label": "#ffffff",
      "glass-fill": "#eff1f4d6",
      "glass-border": "#17202a1a",
      "find-match": "#f2b84b59",
      "find-match-current": "#f2b84b99",
      "accent-soft-solid": "#eaf0f9",
      "success-soft-solid": "#e7f2ee",
      "warning-soft-solid": "#f5f0e7",
      "danger-soft-solid": "#f8ebec",
      "on-cta": "#f5f6f8",
      "glass-tint": "#ffffffc7"
    },
    "syntax": {
      "keyword": "#a626a4",
      "string": "#50a14f",
      "number": "#986801",
      "comment": "#5f6976",
      "variable": "#171a1f",
      "property": "#171a1f",
      "function": "#4078f2",
      "type": "#4078f2",
      "tag": "#e45649",
      "heading": "#e45649",
      "punctuation": "#555e6b",
      "operator": "#555e6b",
      "link": "#2f66c5"
    },
    "ansi": [
      "#eceff3",
      "#b93845",
      "#137a55",
      "#9a650d",
      "#2f66c5",
      "#8540b0",
      "#0f7a87",
      "#555e6b",
      "#5f6976",
      "#ce4a57",
      "#1a8f64",
      "#b57a12",
      "#4a7fd9",
      "#9c55c9",
      "#16909e",
      "#171a1f"
    ]
  },
  {
    "id": "ayu-dark",
    "name": "Ayu Dark",
    "family": "Ayu",
    "author": "Zed Industries",
    "appearance": "dark",
    "colors": {
      "surface-1": "#0d1016",
      "surface-0": "#1f2127",
      "sidebar-surface": "#1f2127",
      "text-primary": "#bfbdb6",
      "text-secondary": "#8a8986",
      "text-tertiary": "#696a6a",
      "surface-2": "#25262c",
      "surface-3": "#2b2d32",
      "border-subtle": "#2d2f34",
      "border-strong": "#3f4043",
      "accent": "#5ac1fe",
      "accent-hover": "#7bcdfe",
      "on-accent": "#0d1016",
      "accent-soft": "#5ac1fe1a",
      "focus-ring": "#5ac1fe4d",
      "success": "#aad84c",
      "success-soft": "#aad84c1f",
      "warning": "#feb454",
      "warning-soft": "#feb4541f",
      "danger": "#ef7177",
      "danger-soft": "#ef71771f",
      "primary-fill": "#bfbdb6",
      "primary-label": "#0d1016",
      "glass-fill": "#1f2127c7",
      "glass-border": "#bfbdb61a",
      "find-match": "#5ac2fe66",
      "find-match-current": "#ea570166",
      "accent-soft-solid": "#15222d",
      "success-soft-solid": "#20281c",
      "warning-soft-solid": "#2a241d",
      "danger-soft-solid": "#281c22",
      "on-cta": "#0d1016",
      "glass-tint": "#0d1016c7"
    },
    "syntax": {
      "keyword": "#ff8f3f",
      "string": "#a9d94b",
      "number": "#d2a6ff",
      "comment": "#5c6773",
      "variable": "#bfbdb6",
      "property": "#5ac1fe",
      "function": "#ffb353",
      "type": "#59c2ff",
      "tag": "#5ac1fe",
      "heading": "#bfbdb6",
      "punctuation": "#a6a5a0",
      "operator": "#f29668",
      "link": "#aad84c"
    },
    "ansi": [
      "#0d1016",
      "#ef7177",
      "#aad84c",
      "#feb454",
      "#5ac1fe",
      "#39bae5",
      "#95e5cb",
      "#bfbdb6",
      "#545557",
      "#83353b",
      "#567627",
      "#92582b",
      "#27618c",
      "#205a78",
      "#4c806f",
      "#fafafa"
    ]
  },
  {
    "id": "ayu-light",
    "name": "Ayu Light",
    "family": "Ayu",
    "author": "Zed Industries",
    "appearance": "light",
    "colors": {
      "surface-1": "#fcfcfc",
      "surface-0": "#ececed",
      "sidebar-surface": "#ececed",
      "text-primary": "#5c6166",
      "text-secondary": "#71757a",
      "text-tertiary": "#8d9194",
      "surface-2": "#e0e1e2",
      "surface-3": "#d9dadb",
      "border-subtle": "#dfe0e1",
      "border-strong": "#cfd1d2",
      "accent": "#3b9ee5",
      "accent-hover": "#3286c3",
      "on-accent": "#fcfcfc",
      "accent-soft": "#3b9ee514",
      "focus-ring": "#3b9ee54d",
      "success": "#85b304",
      "success-soft": "#85b3041a",
      "warning": "#f1ad49",
      "warning-soft": "#f1ad491a",
      "danger": "#ef7271",
      "danger-soft": "#ef72711a",
      "primary-fill": "#5c6166",
      "primary-label": "#fcfcfc",
      "glass-fill": "#ececedd6",
      "glass-border": "#5c61661a",
      "find-match": "#3b9ee566",
      "find-match-current": "#f88b3666",
      "accent-soft-solid": "#edf4fa",
      "success-soft-solid": "#f0f5e3",
      "warning-soft-solid": "#fbf4ea",
      "danger-soft-solid": "#fbeeee",
      "on-cta": "#fcfcfc",
      "glass-tint": "#fcfcfcc7"
    },
    "syntax": {
      "keyword": "#fa8d3e",
      "string": "#86b300",
      "number": "#a37acc",
      "comment": "#abb0b6",
      "variable": "#5c6166",
      "property": "#3b9ee5",
      "function": "#f2ad48",
      "type": "#389ee6",
      "tag": "#3b9ee5",
      "heading": "#5c6166",
      "punctuation": "#73777b",
      "operator": "#ed9365",
      "link": "#85b304"
    },
    "ansi": [
      "#5c6166",
      "#ef7271",
      "#85b304",
      "#f1ad49",
      "#3b9ee5",
      "#55b4d3",
      "#4dbf99",
      "#fcfcfc",
      "#3b9ee5",
      "#febab6",
      "#c7d98f",
      "#fed5a3",
      "#abcdf2",
      "#b1d8e8",
      "#ace0cb",
      "#ffffff"
    ]
  },
  {
    "id": "ayu-mirage",
    "name": "Ayu Mirage",
    "family": "Ayu",
    "author": "Zed Industries",
    "appearance": "dark",
    "colors": {
      "surface-1": "#242835",
      "surface-0": "#353944",
      "sidebar-surface": "#353944",
      "text-primary": "#cccac2",
      "text-secondary": "#9a9a98",
      "text-tertiary": "#7b7d7f",
      "surface-2": "#3a3e48",
      "surface-3": "#40444d",
      "border-subtle": "#43464f",
      "border-strong": "#53565d",
      "accent": "#72cffe",
      "accent-hover": "#8ed9fe",
      "on-accent": "#242835",
      "accent-soft": "#72cffe1a",
      "focus-ring": "#72cffe4d",
      "success": "#d5fe80",
      "success-soft": "#d5fe801f",
      "warning": "#fecf72",
      "warning-soft": "#fecf721f",
      "danger": "#f18779",
      "danger-soft": "#f187791f",
      "primary-fill": "#cccac2",
      "primary-label": "#242835",
      "glass-fill": "#353944c7",
      "glass-border": "#cccac21a",
      "find-match": "#73cffe66",
      "find-match-current": "#fd722b66",
      "accent-soft-solid": "#2c3949",
      "success-soft-solid": "#39423e",
      "warning-soft-solid": "#3e3c3c",
      "danger-soft-solid": "#3d333d",
      "on-cta": "#242835",
      "glass-tint": "#242835c7"
    },
    "syntax": {
      "keyword": "#ffad65",
      "string": "#d4fe7f",
      "number": "#dfbfff",
      "comment": "#5c6773",
      "variable": "#cccac2",
      "property": "#72cffe",
      "function": "#ffd173",
      "type": "#73cfff",
      "tag": "#72cffe",
      "heading": "#cccac2",
      "punctuation": "#b4b3ae",
      "operator": "#f29e74",
      "link": "#d5fe80"
    },
    "ansi": [
      "#242835",
      "#f18779",
      "#d5fe80",
      "#fecf72",
      "#72cffe",
      "#5bcde5",
      "#95e5cb",
      "#cccac2",
      "#67696e",
      "#833f3c",
      "#75993c",
      "#937237",
      "#336d8d",
      "#2b6c7b",
      "#4c806f",
      "#fafafa"
    ]
  },
  {
    "id": "catppuccin-latte",
    "name": "Catppuccin Latte",
    "family": "Catppuccin",
    "author": "Catppuccin <releases@catppuccin.com>",
    "appearance": "light",
    "colors": {
      "surface-1": "#eff1f5",
      "surface-0": "#e6e9ef",
      "sidebar-surface": "#e6e9ef",
      "text-primary": "#4c4f69",
      "text-secondary": "#5c5f77",
      "text-tertiary": "#84889b",
      "surface-2": "#dadde4",
      "surface-3": "#d2d5de",
      "border-subtle": "#e7e2f5",
      "border-strong": "#ccd0da",
      "accent": "#8839ef",
      "accent-hover": "#7430cb",
      "on-accent": "#eff1f5",
      "accent-soft": "#8839ef14",
      "focus-ring": "#8839ef4d",
      "success": "#40a02b",
      "success-soft": "#40a02b1a",
      "warning": "#df8e1d",
      "warning-soft": "#df8e1d1a",
      "danger": "#d20f39",
      "danger-soft": "#d20f391a",
      "primary-fill": "#4c4f69",
      "primary-label": "#eff1f5",
      "glass-fill": "#e6e9efd6",
      "glass-border": "#4c4f691a",
      "find-match": "#1792994d",
      "find-match-current": "#d20f394d",
      "accent-soft-solid": "#e7e2f5",
      "success-soft-solid": "#dee9e1",
      "warning-soft-solid": "#ede7df",
      "danger-soft-solid": "#ecdae2",
      "on-cta": "#eff1f5",
      "glass-tint": "#eff1f5c7"
    },
    "syntax": {
      "keyword": "#8839ef",
      "string": "#40a02b",
      "number": "#fe640b",
      "comment": "#7c7f93",
      "variable": "#4c4f69",
      "property": "#7287fd",
      "function": "#1e66f5",
      "type": "#df8e1d",
      "tag": "#1e66f5",
      "heading": "#d20f39",
      "punctuation": "#7c7f93",
      "operator": "#04a5e5",
      "link": "#1e66f5"
    },
    "ansi": [
      "#5c5f77",
      "#d20f39",
      "#40a02b",
      "#df8e1d",
      "#1e66f5",
      "#ea76cb",
      "#179299",
      "#acb0be",
      "#6c6f85",
      "#de293e",
      "#49af3d",
      "#eea02d",
      "#456eff",
      "#fe85d8",
      "#2d9fa8",
      "#bcc0cc"
    ]
  },
  {
    "id": "catppuccin-frappe",
    "name": "Catppuccin Frappé",
    "family": "Catppuccin",
    "author": "Catppuccin <releases@catppuccin.com>",
    "appearance": "dark",
    "colors": {
      "surface-1": "#303446",
      "surface-0": "#292c3c",
      "sidebar-surface": "#292c3c",
      "text-primary": "#c6d0f5",
      "text-secondary": "#b5bfe2",
      "text-tertiary": "#777e99",
      "surface-2": "#35394c",
      "surface-3": "#3b4053",
      "border-subtle": "#3c3c53",
      "border-strong": "#414559",
      "accent": "#ca9ee6",
      "accent-hover": "#d5b1eb",
      "on-accent": "#303446",
      "accent-soft": "#ca9ee61a",
      "focus-ring": "#ca9ee64d",
      "success": "#a6d189",
      "success-soft": "#a6d1891f",
      "warning": "#e5c890",
      "warning-soft": "#e5c8901f",
      "danger": "#e78284",
      "danger-soft": "#e782841f",
      "primary-fill": "#c6d0f5",
      "primary-label": "#303446",
      "glass-fill": "#292c3cc7",
      "glass-border": "#c6d0f51a",
      "find-match": "#81c8be4d",
      "find-match-current": "#e782844d",
      "accent-soft-solid": "#3f3f56",
      "success-soft-solid": "#3e474e",
      "warning-soft-solid": "#46464f",
      "danger-soft-solid": "#463d4d",
      "on-cta": "#303446",
      "glass-tint": "#303446c7"
    },
    "syntax": {
      "keyword": "#ca9ee6",
      "string": "#a6d189",
      "number": "#ef9f76",
      "comment": "#949cbb",
      "variable": "#c6d0f5",
      "property": "#babbf1",
      "function": "#8caaee",
      "type": "#e5c890",
      "tag": "#8caaee",
      "heading": "#e78284",
      "punctuation": "#949cbb",
      "operator": "#99d1db",
      "link": "#8caaee"
    },
    "ansi": [
      "#51576d",
      "#e78284",
      "#a6d189",
      "#e5c890",
      "#8caaee",
      "#f4b8e4",
      "#81c8be",
      "#a5adce",
      "#626880",
      "#e67172",
      "#8ec772",
      "#d9ba73",
      "#7b9ef0",
      "#f4b8e4",
      "#5abfb5",
      "#b5bfe2"
    ]
  },
  {
    "id": "catppuccin-macchiato",
    "name": "Catppuccin Macchiato",
    "family": "Catppuccin",
    "author": "Catppuccin <releases@catppuccin.com>",
    "appearance": "dark",
    "colors": {
      "surface-1": "#24273a",
      "surface-0": "#1e2030",
      "sidebar-surface": "#1e2030",
      "text-primary": "#cad3f5",
      "text-secondary": "#b8c0e0",
      "text-tertiary": "#6e738d",
      "surface-2": "#2a2d41",
      "surface-3": "#303448",
      "border-subtle": "#313148",
      "border-strong": "#363a4f",
      "accent": "#c6a0f6",
      "accent-hover": "#d1b3f8",
      "on-accent": "#24273a",
      "accent-soft": "#c6a0f61a",
      "focus-ring": "#c6a0f64d",
      "success": "#a6da95",
      "success-soft": "#a6da951f",
      "warning": "#eed49f",
      "warning-soft": "#eed49f1f",
      "danger": "#ed8796",
      "danger-soft": "#ed87961f",
      "primary-fill": "#cad3f5",
      "primary-label": "#24273a",
      "glass-fill": "#1e2030c7",
      "glass-border": "#cad3f51a",
      "find-match": "#8bd5ca4d",
      "find-match-current": "#ed87964d",
      "accent-soft-solid": "#34334d",
      "success-soft-solid": "#343c45",
      "warning-soft-solid": "#3c3c46",
      "danger-soft-solid": "#3c3345",
      "on-cta": "#24273a",
      "glass-tint": "#24273ac7"
    },
    "syntax": {
      "keyword": "#c6a0f6",
      "string": "#a6da95",
      "number": "#f5a97f",
      "comment": "#939ab7",
      "variable": "#cad3f5",
      "property": "#b7bdf8",
      "function": "#8aadf4",
      "type": "#eed49f",
      "tag": "#8aadf4",
      "heading": "#ed8796",
      "punctuation": "#939ab7",
      "operator": "#91d7e3",
      "link": "#8aadf4"
    },
    "ansi": [
      "#494d64",
      "#ed8796",
      "#a6da95",
      "#eed49f",
      "#8aadf4",
      "#f5bde6",
      "#8bd5ca",
      "#a5adcb",
      "#5b6078",
      "#ec7486",
      "#8ccf7f",
      "#e1c682",
      "#78a1f6",
      "#f2a9dd",
      "#63cbc0",
      "#b8c0e0"
    ]
  },
  {
    "id": "catppuccin-mocha",
    "name": "Catppuccin Mocha",
    "family": "Catppuccin",
    "author": "Catppuccin <releases@catppuccin.com>",
    "appearance": "dark",
    "colors": {
      "surface-1": "#1e1e2e",
      "surface-0": "#181825",
      "sidebar-surface": "#181825",
      "text-primary": "#cdd6f4",
      "text-secondary": "#bac2de",
      "text-tertiary": "#676a81",
      "surface-2": "#242435",
      "surface-3": "#2b2c3d",
      "border-subtle": "#2c293d",
      "border-strong": "#313244",
      "accent": "#cba6f7",
      "accent-hover": "#d5b8f9",
      "on-accent": "#1e1e2e",
      "accent-soft": "#cba6f71a",
      "focus-ring": "#cba6f74d",
      "success": "#a6e3a1",
      "success-soft": "#a6e3a11f",
      "warning": "#f9e2af",
      "warning-soft": "#f9e2af1f",
      "danger": "#f38ba8",
      "danger-soft": "#f38ba81f",
      "primary-fill": "#cdd6f4",
      "primary-label": "#1e1e2e",
      "glass-fill": "#181825c7",
      "glass-border": "#cdd6f41a",
      "find-match": "#94e2d54d",
      "find-match-current": "#f38ba84d",
      "accent-soft-solid": "#2f2c42",
      "success-soft-solid": "#2e363c",
      "warning-soft-solid": "#38363d",
      "danger-soft-solid": "#382b3d",
      "on-cta": "#1e1e2e",
      "glass-tint": "#1e1e2ec7"
    },
    "syntax": {
      "keyword": "#cba6f7",
      "string": "#a6e3a1",
      "number": "#fab387",
      "comment": "#9399b2",
      "variable": "#cdd6f4",
      "property": "#b4befe",
      "function": "#89b4fa",
      "type": "#f9e2af",
      "tag": "#89b4fa",
      "heading": "#f38ba8",
      "punctuation": "#9399b2",
      "operator": "#89dceb",
      "link": "#89b4fa"
    },
    "ansi": [
      "#45475a",
      "#f38ba8",
      "#a6e3a1",
      "#f9e2af",
      "#89b4fa",
      "#f5c2e7",
      "#94e2d5",
      "#a6adc8",
      "#585b70",
      "#f37799",
      "#89d88b",
      "#ebd391",
      "#74a8fc",
      "#f2aede",
      "#6bd7ca",
      "#bac2de"
    ]
  },
  {
    "id": "dracula",
    "name": "Dracula",
    "family": "Dracula",
    "author": "Ben Hamment",
    "appearance": "dark",
    "colors": {
      "surface-1": "#282a36",
      "surface-0": "#16121b",
      "sidebar-surface": "#16121b",
      "text-primary": "#f8f8f2",
      "text-secondary": "#a186c7",
      "text-tertiary": "#7d6c9d",
      "surface-2": "#2f313d",
      "surface-3": "#383944",
      "border-subtle": "#c9a8f933",
      "border-strong": "#3c324bcc",
      "accent": "#c9a8f9",
      "accent-hover": "#d4b9fa",
      "on-accent": "#282a36",
      "accent-soft": "#c9a8f91a",
      "focus-ring": "#c9a8f94d",
      "success": "#79e96d",
      "success-soft": "#79e96d1f",
      "warning": "#e6e373",
      "warning-soft": "#e6e3731f",
      "danger": "#e67373",
      "danger-soft": "#e673731f",
      "primary-fill": "#f8f8f2",
      "primary-label": "#282a36",
      "glass-fill": "#16121bc7",
      "glass-border": "#f8f8f21a",
      "find-match": "#50fa7b50",
      "find-match-current": "#e6e37399",
      "accent-soft-solid": "#38374a",
      "success-soft-solid": "#32413d",
      "warning-soft-solid": "#3f403d",
      "danger-soft-solid": "#3f333d",
      "on-cta": "#282a36",
      "glass-tint": "#282a36c7"
    },
    "syntax": {
      "keyword": "#ff79c6",
      "string": "#f1fa8c",
      "number": "#bd93f9",
      "comment": "#6272a4",
      "variable": "#f8f8f2",
      "property": "#8be9fd",
      "function": "#50fa7b",
      "type": "#8be9fd",
      "tag": "#ff79c6",
      "heading": "#bd93f9",
      "punctuation": "#ff79c6",
      "operator": "#ff79c6",
      "link": "#8be9fd"
    },
    "ansi": [
      "#21222c",
      "#ff5555",
      "#50fa7b",
      "#f1fa8c",
      "#9580ff",
      "#ff79c6",
      "#8be9fd",
      "#f8f8f2",
      "#919cbf",
      "#ff6e6e",
      "#69ff94",
      "#ffffa5",
      "#d6acff",
      "#ff92df",
      "#a4ffff",
      "#ffffff"
    ]
  },
  {
    "id": "dracula-solid",
    "name": "Dracula Solid",
    "family": "Dracula",
    "author": "Ben Hamment",
    "appearance": "dark",
    "colors": {
      "surface-1": "#282a36",
      "surface-0": "#0a080c",
      "sidebar-surface": "#0a080c",
      "text-primary": "#f8f8f2",
      "text-secondary": "#a186c7",
      "text-tertiary": "#a186c7",
      "surface-2": "#2f313d",
      "surface-3": "#383944",
      "border-subtle": "#504364",
      "border-strong": "#3c324b",
      "accent": "#c9a8f9",
      "accent-hover": "#d4b9fa",
      "on-accent": "#282a36",
      "accent-soft": "#c9a8f91a",
      "focus-ring": "#c9a8f94d",
      "success": "#79e96d",
      "success-soft": "#79e96d1f",
      "warning": "#e6e373",
      "warning-soft": "#e6e3731f",
      "danger": "#e67373",
      "danger-soft": "#e673731f",
      "primary-fill": "#f8f8f2",
      "primary-label": "#282a36",
      "glass-fill": "#0a080cc7",
      "glass-border": "#f8f8f21a",
      "find-match": "#287d3e",
      "find-match-current": "#e6e37399",
      "accent-soft-solid": "#38374a",
      "success-soft-solid": "#32413d",
      "warning-soft-solid": "#3f403d",
      "danger-soft-solid": "#3f333d",
      "on-cta": "#282a36",
      "glass-tint": "#282a36c7"
    },
    "syntax": {
      "keyword": "#ff79c6",
      "string": "#f1fa8c",
      "number": "#bd93f9",
      "comment": "#6272a4",
      "variable": "#f8f8f2",
      "property": "#8be9fd",
      "function": "#50fa7b",
      "type": "#8be9fd",
      "tag": "#ff79c6",
      "heading": "#bd93f9",
      "punctuation": "#ff79c6",
      "operator": "#ff79c6",
      "link": "#8be9fd"
    },
    "ansi": [
      "#21222c",
      "#ff5555",
      "#50fa7b",
      "#f1fa8c",
      "#9580ff",
      "#ff79c6",
      "#8be9fd",
      "#f8f8f2",
      "#919cbf",
      "#ff6e6e",
      "#69ff94",
      "#ffffa5",
      "#d6acff",
      "#ff92df",
      "#a4ffff",
      "#ffffff"
    ]
  },
  {
    "id": "dracula-light-alucard",
    "name": "Dracula Light (Alucard)",
    "family": "Dracula",
    "author": "Ben Hamment",
    "appearance": "light",
    "colors": {
      "surface-1": "#f5f5f5",
      "surface-0": "#edeff4",
      "sidebar-surface": "#edeff4",
      "text-primary": "#1f1f1f",
      "text-secondary": "#353535",
      "text-tertiary": "#8a8a8a",
      "surface-2": "#dddee3",
      "surface-3": "#d2d4d8",
      "border-subtle": "#e4e4e4",
      "border-strong": "#d1c9ef",
      "accent": "#836ed4",
      "accent-hover": "#6f5eb4",
      "on-accent": "#1f1f1f",
      "accent-soft": "#836ed414",
      "focus-ring": "#836ed44d",
      "success": "#1b7108",
      "success-soft": "#1b71081a",
      "warning": "#ccb517",
      "warning-soft": "#ccb5171a",
      "danger": "#b83233",
      "danger-soft": "#b832331a",
      "primary-fill": "#1f1f1f",
      "primary-label": "#f5f5f5",
      "glass-fill": "#edeff4d6",
      "glass-border": "#1f1f1f1a",
      "find-match": "#14710a30",
      "find-match-current": "#ccb51799",
      "accent-soft-solid": "#eceaf2",
      "success-soft-solid": "#dfe8dd",
      "warning-soft-solid": "#f1efdf",
      "danger-soft-solid": "#efe2e2",
      "on-cta": "#f5f5f5",
      "glass-tint": "#f5f5f5c7"
    },
    "syntax": {
      "keyword": "#a3144d",
      "string": "#846e15",
      "number": "#644ac9",
      "comment": "#635d97",
      "variable": "#1f1f1f",
      "property": "#036a96",
      "function": "#14710a",
      "type": "#036a96",
      "tag": "#a3144d",
      "heading": "#644ac9",
      "punctuation": "#a3144d",
      "operator": "#a3144d",
      "link": "#036a96"
    },
    "ansi": [
      "#f5f5f5",
      "#cb3a2a",
      "#14710a",
      "#846e15",
      "#644ac9",
      "#a3144d",
      "#036a96",
      "#1f1f1f",
      "#928eb6",
      "#d74c3d",
      "#198d0c",
      "#9e841a",
      "#7862d0",
      "#bf185a",
      "#047fb4",
      "#2c2b31"
    ]
  },
  {
    "id": "github-light",
    "name": "GitHub Light",
    "family": "GitHub Theme",
    "author": "Pyae Sone Aung",
    "appearance": "light",
    "colors": {
      "surface-1": "#ffffff",
      "surface-0": "#f6f8fa",
      "sidebar-surface": "#f6f8fa",
      "text-primary": "#1f2328",
      "text-secondary": "#1f2328",
      "text-tertiary": "#59636e",
      "surface-2": "#e5e7e9",
      "surface-3": "#dadcdf",
      "border-subtle": "#d1d9e0b3",
      "border-strong": "#d1d9e0",
      "accent": "#0969da",
      "accent-hover": "#0859b9",
      "on-accent": "#ffffff",
      "accent-soft": "#0969da14",
      "focus-ring": "#0969da4d",
      "success": "#1a7f37",
      "success-soft": "#1a7f371a",
      "warning": "#9a6700",
      "warning-soft": "#9a67001a",
      "danger": "#d1242f",
      "danger-soft": "#d1242f1a",
      "primary-fill": "#1f2328",
      "primary-label": "#ffffff",
      "glass-fill": "#f6f8fad6",
      "glass-border": "#1f23281a",
      "find-match": "#fae17d4d",
      "find-match-current": "#9a670099",
      "accent-soft-solid": "#ebf3fc",
      "success-soft-solid": "#e8f2eb",
      "warning-soft-solid": "#f5f0e6",
      "danger-soft-solid": "#fae9ea",
      "on-cta": "#ffffff",
      "glass-tint": "#ffffffc7"
    },
    "syntax": {
      "keyword": "#cf222e",
      "string": "#0a3069",
      "number": "#0550ae",
      "comment": "#59636e",
      "variable": "#1f2328",
      "property": "#1f2328",
      "function": "#8250df",
      "type": "#953800",
      "tag": "#116329",
      "heading": "#0550ae",
      "punctuation": "#cf222e",
      "operator": "#cf222e",
      "link": "#0550ae"
    },
    "ansi": [
      "#1f2328",
      "#cf222e",
      "#116329",
      "#4d2d00",
      "#0969da",
      "#8250df",
      "#1b7c83",
      "#59636e",
      "#393f46",
      "#a40e26",
      "#1a7f37",
      "#633c01",
      "#218bff",
      "#a475f9",
      "#3192aa",
      "#818b98"
    ]
  },
  {
    "id": "github-light-colorblind",
    "name": "GitHub Light Colorblind",
    "family": "GitHub Theme",
    "author": "Pyae Sone Aung",
    "appearance": "light",
    "colors": {
      "surface-1": "#ffffff",
      "surface-0": "#f6f8fa",
      "sidebar-surface": "#f6f8fa",
      "text-primary": "#1f2328",
      "text-secondary": "#1f2328",
      "text-tertiary": "#59636e",
      "surface-2": "#e5e7e9",
      "surface-3": "#dadcdf",
      "border-subtle": "#d1d9e0b3",
      "border-strong": "#d1d9e0",
      "accent": "#0969da",
      "accent-hover": "#0859b9",
      "on-accent": "#ffffff",
      "accent-soft": "#0969da14",
      "focus-ring": "#0969da4d",
      "success": "#0969da",
      "success-soft": "#0969da1a",
      "warning": "#9a6700",
      "warning-soft": "#9a67001a",
      "danger": "#bc4c00",
      "danger-soft": "#bc4c001a",
      "primary-fill": "#1f2328",
      "primary-label": "#ffffff",
      "glass-fill": "#f6f8fad6",
      "glass-border": "#1f23281a",
      "find-match": "#fae17d4d",
      "find-match-current": "#9a670099",
      "accent-soft-solid": "#ebf3fc",
      "success-soft-solid": "#e6f0fb",
      "warning-soft-solid": "#f5f0e6",
      "danger-soft-solid": "#f8ede6",
      "on-cta": "#ffffff",
      "glass-tint": "#ffffffc7"
    },
    "syntax": {
      "keyword": "#cf222e",
      "string": "#0a3069",
      "number": "#0550ae",
      "comment": "#59636e",
      "variable": "#1f2328",
      "property": "#1f2328",
      "function": "#8250df",
      "type": "#953800",
      "tag": "#116329",
      "heading": "#0550ae",
      "punctuation": "#cf222e",
      "operator": "#cf222e",
      "link": "#0550ae"
    },
    "ansi": [
      "#1f2328",
      "#bc4c00",
      "#0550ae",
      "#4d2d00",
      "#0969da",
      "#8250df",
      "#1b7c83",
      "#59636e",
      "#393f46",
      "#953800",
      "#0969da",
      "#633c01",
      "#218bff",
      "#a475f9",
      "#3192aa",
      "#818b98"
    ]
  },
  {
    "id": "github-light-high-contrast",
    "name": "GitHub Light High Contrast",
    "family": "GitHub Theme",
    "author": "Pyae Sone Aung",
    "appearance": "light",
    "colors": {
      "surface-1": "#ffffff",
      "surface-0": "#eff2f5",
      "sidebar-surface": "#eff2f5",
      "text-primary": "#010409",
      "text-secondary": "#010409",
      "text-tertiary": "#454c54",
      "surface-2": "#dcdfe2",
      "surface-3": "#d0d3d6",
      "border-subtle": "#454c54",
      "border-strong": "#454c54",
      "accent": "#023b95",
      "accent-hover": "#02327f",
      "on-accent": "#ffffff",
      "accent-soft": "#023b9514",
      "focus-ring": "#023b954d",
      "success": "#024c1a",
      "success-soft": "#024c1a1a",
      "warning": "#603700",
      "warning-soft": "#6037001a",
      "danger": "#86061d",
      "danger-soft": "#86061d1a",
      "primary-fill": "#010409",
      "primary-label": "#ffffff",
      "glass-fill": "#eff2f5d6",
      "glass-border": "#0104091a",
      "find-match": "#f0ce534d",
      "find-match-current": "#60370099",
      "accent-soft-solid": "#ebeff7",
      "success-soft-solid": "#e6ede8",
      "warning-soft-solid": "#efebe6",
      "danger-soft-solid": "#f3e6e8",
      "on-cta": "#ffffff",
      "glass-tint": "#ffffffc7"
    },
    "syntax": {
      "keyword": "#a0111f",
      "string": "#032563",
      "number": "#023b95",
      "comment": "#59636e",
      "variable": "#010409",
      "property": "#010409",
      "function": "#622cbc",
      "type": "#702c00",
      "tag": "#024c1a",
      "heading": "#023b95",
      "punctuation": "#a0111f",
      "operator": "#a0111f",
      "link": "#023b95"
    },
    "ansi": [
      "#010409",
      "#a0111f",
      "#024c1a",
      "#3f2200",
      "#0349b4",
      "#622cbc",
      "#1b7c83",
      "#59636e",
      "#393f46",
      "#86061d",
      "#055d20",
      "#4e2c00",
      "#1168e3",
      "#844ae7",
      "#3192aa",
      "#818b98"
    ]
  },
  {
    "id": "github-light-tritanopia",
    "name": "GitHub Light Tritanopia",
    "family": "GitHub Theme",
    "author": "Pyae Sone Aung",
    "appearance": "light",
    "colors": {
      "surface-1": "#ffffff",
      "surface-0": "#f6f8fa",
      "sidebar-surface": "#f6f8fa",
      "text-primary": "#1f2328",
      "text-secondary": "#1f2328",
      "text-tertiary": "#59636e",
      "surface-2": "#e5e7e9",
      "surface-3": "#dadcdf",
      "border-subtle": "#d1d9e0b3",
      "border-strong": "#d1d9e0",
      "accent": "#0969da",
      "accent-hover": "#0859b9",
      "on-accent": "#ffffff",
      "accent-soft": "#0969da14",
      "focus-ring": "#0969da4d",
      "success": "#0969da",
      "success-soft": "#0969da1a",
      "warning": "#9a6700",
      "warning-soft": "#9a67001a",
      "danger": "#d1242f",
      "danger-soft": "#d1242f1a",
      "primary-fill": "#1f2328",
      "primary-label": "#ffffff",
      "glass-fill": "#f6f8fad6",
      "glass-border": "#1f23281a",
      "find-match": "#fae17d4d",
      "find-match-current": "#9a670099",
      "accent-soft-solid": "#ebf3fc",
      "success-soft-solid": "#e6f0fb",
      "warning-soft-solid": "#f5f0e6",
      "danger-soft-solid": "#fae9ea",
      "on-cta": "#ffffff",
      "glass-tint": "#ffffffc7"
    },
    "syntax": {
      "keyword": "#cf222e",
      "string": "#0a3069",
      "number": "#0550ae",
      "comment": "#59636e",
      "variable": "#1f2328",
      "property": "#1f2328",
      "function": "#8250df",
      "type": "#953800",
      "tag": "#116329",
      "heading": "#0550ae",
      "punctuation": "#cf222e",
      "operator": "#cf222e",
      "link": "#0550ae"
    },
    "ansi": [
      "#1f2328",
      "#cf222e",
      "#0550ae",
      "#4d2d00",
      "#0969da",
      "#8250df",
      "#1b7c83",
      "#59636e",
      "#393f46",
      "#a40e26",
      "#0969da",
      "#633c01",
      "#218bff",
      "#a475f9",
      "#3192aa",
      "#818b98"
    ]
  },
  {
    "id": "github-dark",
    "name": "GitHub Dark",
    "family": "GitHub Theme",
    "author": "Pyae Sone Aung",
    "appearance": "dark",
    "colors": {
      "surface-1": "#0d1117",
      "surface-0": "#010409",
      "sidebar-surface": "#010409",
      "text-primary": "#f0f6fc",
      "text-secondary": "#f0f6fc",
      "text-tertiary": "#9198a1",
      "surface-2": "#15191f",
      "surface-3": "#1e2228",
      "border-subtle": "#3d444db3",
      "border-strong": "#3d444d",
      "accent": "#4493f8",
      "accent-hover": "#69a9f9",
      "on-accent": "#0d1117",
      "accent-soft": "#4493f81a",
      "focus-ring": "#4493f84d",
      "success": "#3fb950",
      "success-soft": "#3fb9501f",
      "warning": "#d29922",
      "warning-soft": "#d299221f",
      "danger": "#f85149",
      "danger-soft": "#f851491f",
      "primary-fill": "#f0f6fc",
      "primary-label": "#0d1117",
      "glass-fill": "#010409c7",
      "glass-border": "#f0f6fc1a",
      "find-match": "#f2cc604d",
      "find-match-current": "#d2992299",
      "accent-soft-solid": "#131e2e",
      "success-soft-solid": "#13251e",
      "warning-soft-solid": "#252118",
      "danger-soft-solid": "#29191d",
      "on-cta": "#0d1117",
      "glass-tint": "#0d1117c7"
    },
    "syntax": {
      "keyword": "#ff7b72",
      "string": "#a5d6ff",
      "number": "#79c0ff",
      "comment": "#9198a1",
      "variable": "#f0f6fc",
      "property": "#f0f6fc",
      "function": "#d2a8ff",
      "type": "#ffa657",
      "tag": "#7ee787",
      "heading": "#79c0ff",
      "punctuation": "#ff7b72",
      "operator": "#ff7b72",
      "link": "#79c0ff"
    },
    "ansi": [
      "#2f3742",
      "#ff7b72",
      "#3fb950",
      "#d29922",
      "#58a6ff",
      "#be8fff",
      "#39c5cf",
      "#f0f6fc",
      "#656c76",
      "#ffa198",
      "#56d364",
      "#e3b341",
      "#79c0ff",
      "#d2a8ff",
      "#56d4dd",
      "#ffffff"
    ]
  },
  {
    "id": "github-dark-colorblind",
    "name": "GitHub Dark Colorblind",
    "family": "GitHub Theme",
    "author": "Pyae Sone Aung",
    "appearance": "dark",
    "colors": {
      "surface-1": "#0d1117",
      "surface-0": "#010409",
      "sidebar-surface": "#010409",
      "text-primary": "#f0f6fc",
      "text-secondary": "#f0f6fc",
      "text-tertiary": "#9198a1",
      "surface-2": "#15191f",
      "surface-3": "#1e2228",
      "border-subtle": "#3d444db3",
      "border-strong": "#3d444d",
      "accent": "#4493f8",
      "accent-hover": "#69a9f9",
      "on-accent": "#0d1117",
      "accent-soft": "#4493f81a",
      "focus-ring": "#4493f84d",
      "success": "#58a6ff",
      "success-soft": "#58a6ff1f",
      "warning": "#d29922",
      "warning-soft": "#d299221f",
      "danger": "#f0883e",
      "danger-soft": "#f0883e1f",
      "primary-fill": "#f0f6fc",
      "primary-label": "#0d1117",
      "glass-fill": "#010409c7",
      "glass-border": "#f0f6fc1a",
      "find-match": "#f2cc604d",
      "find-match-current": "#d2992299",
      "accent-soft-solid": "#131e2e",
      "success-soft-solid": "#162333",
      "warning-soft-solid": "#252118",
      "danger-soft-solid": "#281f1c",
      "on-cta": "#0d1117",
      "glass-tint": "#0d1117c7"
    },
    "syntax": {
      "keyword": "#ff7b72",
      "string": "#a5d6ff",
      "number": "#79c0ff",
      "comment": "#9198a1",
      "variable": "#f0f6fc",
      "property": "#f0f6fc",
      "function": "#d2a8ff",
      "type": "#ffa657",
      "tag": "#7ee787",
      "heading": "#79c0ff",
      "punctuation": "#ff7b72",
      "operator": "#ff7b72",
      "link": "#79c0ff"
    },
    "ansi": [
      "#2f3742",
      "#f0883e",
      "#58a6ff",
      "#d29922",
      "#58a6ff",
      "#be8fff",
      "#39c5cf",
      "#f0f6fc",
      "#656c76",
      "#ffa657",
      "#79c0ff",
      "#e3b341",
      "#79c0ff",
      "#d2a8ff",
      "#56d4dd",
      "#ffffff"
    ]
  },
  {
    "id": "github-dark-high-contrast",
    "name": "GitHub Dark High Contrast",
    "family": "GitHub Theme",
    "author": "Pyae Sone Aung",
    "appearance": "dark",
    "colors": {
      "surface-1": "#010409",
      "surface-0": "#010409",
      "sidebar-surface": "#010409",
      "text-primary": "#ffffff",
      "text-secondary": "#ffffff",
      "text-tertiary": "#b7bdc8",
      "surface-2": "#0a0d12",
      "surface-3": "#14171b",
      "border-subtle": "#b7bdc8",
      "border-strong": "#b7bdc8",
      "accent": "#74b9ff",
      "accent-hover": "#90c7ff",
      "on-accent": "#010409",
      "accent-soft": "#74b9ff1a",
      "focus-ring": "#74b9ff4d",
      "success": "#2bd853",
      "success-soft": "#2bd8531f",
      "warning": "#f0b72f",
      "warning-soft": "#f0b72f1f",
      "danger": "#ff9492",
      "danger-soft": "#ff94921f",
      "primary-fill": "#ffffff",
      "primary-label": "#010409",
      "glass-fill": "#010409c7",
      "glass-border": "#ffffff1a",
      "find-match": "#fbd6694d",
      "find-match-current": "#f0b72f99",
      "accent-soft-solid": "#0d1622",
      "success-soft-solid": "#061d12",
      "warning-soft-solid": "#1e190e",
      "danger-soft-solid": "#1f1519",
      "on-cta": "#010409",
      "glass-tint": "#010409c7"
    },
    "syntax": {
      "keyword": "#ff9492",
      "string": "#addcff",
      "number": "#91cbff",
      "comment": "#9198a1",
      "variable": "#ffffff",
      "property": "#ffffff",
      "function": "#dbb7ff",
      "type": "#ffb757",
      "tag": "#72f088",
      "heading": "#91cbff",
      "punctuation": "#ff9492",
      "operator": "#ff9492",
      "link": "#91cbff"
    },
    "ansi": [
      "#2f3742",
      "#ff9492",
      "#28d751",
      "#f0b72f",
      "#71b7ff",
      "#cb9eff",
      "#39c5cf",
      "#f0f6fc",
      "#656c76",
      "#ffb1af",
      "#4ae168",
      "#f7c843",
      "#91cbff",
      "#dbb7ff",
      "#56d4dd",
      "#ffffff"
    ]
  },
  {
    "id": "github-dark-tritanopia",
    "name": "GitHub Dark Tritanopia",
    "family": "GitHub Theme",
    "author": "Pyae Sone Aung",
    "appearance": "dark",
    "colors": {
      "surface-1": "#0d1117",
      "surface-0": "#010409",
      "sidebar-surface": "#010409",
      "text-primary": "#f0f6fc",
      "text-secondary": "#f0f6fc",
      "text-tertiary": "#9198a1",
      "surface-2": "#15191f",
      "surface-3": "#1e2228",
      "border-subtle": "#3d444db3",
      "border-strong": "#3d444d",
      "accent": "#4493f8",
      "accent-hover": "#69a9f9",
      "on-accent": "#0d1117",
      "accent-soft": "#4493f81a",
      "focus-ring": "#4493f84d",
      "success": "#58a6ff",
      "success-soft": "#58a6ff1f",
      "warning": "#d29922",
      "warning-soft": "#d299221f",
      "danger": "#f85149",
      "danger-soft": "#f851491f",
      "primary-fill": "#f0f6fc",
      "primary-label": "#0d1117",
      "glass-fill": "#010409c7",
      "glass-border": "#f0f6fc1a",
      "find-match": "#f2cc604d",
      "find-match-current": "#d2992299",
      "accent-soft-solid": "#131e2e",
      "success-soft-solid": "#162333",
      "warning-soft-solid": "#252118",
      "danger-soft-solid": "#29191d",
      "on-cta": "#0d1117",
      "glass-tint": "#0d1117c7"
    },
    "syntax": {
      "keyword": "#ff7b72",
      "string": "#a5d6ff",
      "number": "#79c0ff",
      "comment": "#9198a1",
      "variable": "#f0f6fc",
      "property": "#f0f6fc",
      "function": "#d2a8ff",
      "type": "#ffa657",
      "tag": "#7ee787",
      "heading": "#79c0ff",
      "punctuation": "#ff7b72",
      "operator": "#ff7b72",
      "link": "#79c0ff"
    },
    "ansi": [
      "#2f3742",
      "#ff7b72",
      "#58a6ff",
      "#d29922",
      "#58a6ff",
      "#be8fff",
      "#39c5cf",
      "#f0f6fc",
      "#656c76",
      "#ffa198",
      "#79c0ff",
      "#e3b341",
      "#79c0ff",
      "#d2a8ff",
      "#56d4dd",
      "#ffffff"
    ]
  },
  {
    "id": "github-dark-dimmed",
    "name": "GitHub Dark Dimmed",
    "family": "GitHub Theme",
    "author": "Pyae Sone Aung",
    "appearance": "dark",
    "colors": {
      "surface-1": "#212830",
      "surface-0": "#151b23",
      "sidebar-surface": "#151b23",
      "text-primary": "#d1d7e0",
      "text-secondary": "#d1d7e0",
      "text-tertiary": "#9198a1",
      "surface-2": "#272e36",
      "surface-3": "#2e353d",
      "border-subtle": "#3d444db3",
      "border-strong": "#3d444d",
      "accent": "#478be6",
      "accent-hover": "#6ca2eb",
      "on-accent": "#212830",
      "accent-soft": "#478be61a",
      "focus-ring": "#478be64d",
      "success": "#57ab5a",
      "success-soft": "#57ab5a1f",
      "warning": "#c69026",
      "warning-soft": "#c690261f",
      "danger": "#e5534b",
      "danger-soft": "#e5534b1f",
      "primary-fill": "#d1d7e0",
      "primary-label": "#212830",
      "glass-fill": "#151b23c7",
      "glass-border": "#d1d7e01a",
      "find-match": "#eac55f4d",
      "find-match-current": "#c6902699",
      "accent-soft-solid": "#253242",
      "success-soft-solid": "#273835",
      "warning-soft-solid": "#35342f",
      "danger-soft-solid": "#392d33",
      "on-cta": "#212830",
      "glass-tint": "#212830c7"
    },
    "syntax": {
      "keyword": "#f47067",
      "string": "#96d0ff",
      "number": "#6cb6ff",
      "comment": "#9198a1",
      "variable": "#d1d7e0",
      "property": "#d1d7e0",
      "function": "#dcbdfb",
      "type": "#f69d50",
      "tag": "#8ddb8c",
      "heading": "#6cb6ff",
      "punctuation": "#f47067",
      "operator": "#f47067",
      "link": "#6cb6ff"
    },
    "ansi": [
      "#2f3742",
      "#f47067",
      "#57ab5a",
      "#c69026",
      "#539bf5",
      "#b083f0",
      "#39c5cf",
      "#f0f6fc",
      "#656c76",
      "#ff938a",
      "#6bc46d",
      "#daaa3f",
      "#6cb6ff",
      "#dcbdfb",
      "#56d4dd",
      "#cdd9e5"
    ]
  },
  {
    "id": "gruvbox-dark",
    "name": "Gruvbox Dark",
    "family": "Gruvbox",
    "author": "Zed Industries",
    "appearance": "dark",
    "colors": {
      "surface-1": "#282828",
      "surface-0": "#3a3735",
      "sidebar-surface": "#3a3735",
      "text-primary": "#fbf1c7",
      "text-secondary": "#c5b597",
      "text-tertiary": "#998b78",
      "surface-2": "#413e3a",
      "surface-3": "#484540",
      "border-subtle": "#494340",
      "border-strong": "#5b534d",
      "accent": "#83a598",
      "accent-hover": "#9cb7ad",
      "on-accent": "#282828",
      "accent-soft": "#83a5981a",
      "focus-ring": "#83a5984d",
      "success": "#b7bb26",
      "success-soft": "#b7bb261f",
      "warning": "#f9bd2f",
      "warning-soft": "#f9bd2f1f",
      "danger": "#fb4a35",
      "danger-soft": "#fb4a351f",
      "primary-fill": "#fbf1c7",
      "primary-label": "#282828",
      "glass-fill": "#3a3735c7",
      "glass-border": "#fbf1c71a",
      "find-match": "#83a59866",
      "find-match-current": "#c09f3f66",
      "accent-soft-solid": "#313533",
      "success-soft-solid": "#393a28",
      "warning-soft-solid": "#413a29",
      "danger-soft-solid": "#412c2a",
      "on-cta": "#282828",
      "glass-tint": "#282828c7"
    },
    "syntax": {
      "keyword": "#fb4833",
      "string": "#b8bb25",
      "number": "#d3869b",
      "comment": "#a89984",
      "variable": "#ebdbb2",
      "property": "#ebdbb2",
      "function": "#b8bb25",
      "type": "#fabd2e",
      "tag": "#8ec07c",
      "heading": "#b8bb25",
      "punctuation": "#d5c4a1",
      "operator": "#8ec07c",
      "link": "#d3869b"
    },
    "ansi": [
      "#282828",
      "#cc241d",
      "#98971a",
      "#d79921",
      "#458588",
      "#b16286",
      "#689d6a",
      "#a89984",
      "#928374",
      "#fb4934",
      "#b8bb26",
      "#fabd2f",
      "#83a598",
      "#d3869b",
      "#8ec07c",
      "#fbf1c7"
    ]
  },
  {
    "id": "gruvbox-dark-hard",
    "name": "Gruvbox Dark Hard",
    "family": "Gruvbox",
    "author": "Zed Industries",
    "appearance": "dark",
    "colors": {
      "surface-1": "#1d2021",
      "surface-0": "#393634",
      "sidebar-surface": "#393634",
      "text-primary": "#fbf1c7",
      "text-secondary": "#c5b597",
      "text-tertiary": "#998b78",
      "surface-2": "#403d39",
      "surface-3": "#48443f",
      "border-subtle": "#494340",
      "border-strong": "#5b534d",
      "accent": "#83a598",
      "accent-hover": "#9cb7ad",
      "on-accent": "#1d2021",
      "accent-soft": "#83a5981a",
      "focus-ring": "#83a5984d",
      "success": "#b7bb26",
      "success-soft": "#b7bb261f",
      "warning": "#f9bd2f",
      "warning-soft": "#f9bd2f1f",
      "danger": "#fb4a35",
      "danger-soft": "#fb4a351f",
      "primary-fill": "#fbf1c7",
      "primary-label": "#1d2021",
      "glass-fill": "#393634c7",
      "glass-border": "#fbf1c71a",
      "find-match": "#83a59866",
      "find-match-current": "#c9653666",
      "accent-soft-solid": "#272d2d",
      "success-soft-solid": "#2f3322",
      "warning-soft-solid": "#373323",
      "danger-soft-solid": "#382523",
      "on-cta": "#1d2021",
      "glass-tint": "#1d2021c7"
    },
    "syntax": {
      "keyword": "#fb4833",
      "string": "#b8bb25",
      "number": "#d3869b",
      "comment": "#a89984",
      "variable": "#ebdbb2",
      "property": "#ebdbb2",
      "function": "#b8bb25",
      "type": "#fabd2e",
      "tag": "#8ec07c",
      "heading": "#b8bb25",
      "punctuation": "#d5c4a1",
      "operator": "#8ec07c",
      "link": "#d3869b"
    },
    "ansi": [
      "#282828",
      "#cc241d",
      "#98971a",
      "#d79921",
      "#458588",
      "#b16286",
      "#689d6a",
      "#a89984",
      "#928374",
      "#fb4934",
      "#b8bb26",
      "#fabd2f",
      "#83a598",
      "#d3869b",
      "#8ec07c",
      "#fbf1c7"
    ]
  },
  {
    "id": "gruvbox-dark-soft",
    "name": "Gruvbox Dark Soft",
    "family": "Gruvbox",
    "author": "Zed Industries",
    "appearance": "dark",
    "colors": {
      "surface-1": "#32302f",
      "surface-0": "#3b3735",
      "sidebar-surface": "#3b3735",
      "text-primary": "#fbf1c7",
      "text-secondary": "#c5b597",
      "text-tertiary": "#998b78",
      "surface-2": "#423e3a",
      "surface-3": "#494540",
      "border-subtle": "#494340",
      "border-strong": "#5b534d",
      "accent": "#83a598",
      "accent-hover": "#9cb7ad",
      "on-accent": "#32302f",
      "accent-soft": "#83a5981a",
      "focus-ring": "#83a5984d",
      "success": "#b7bb26",
      "success-soft": "#b7bb261f",
      "warning": "#f9bd2f",
      "warning-soft": "#f9bd2f1f",
      "danger": "#fb4a35",
      "danger-soft": "#fb4a351f",
      "primary-fill": "#fbf1c7",
      "primary-label": "#32302f",
      "glass-fill": "#3b3735c7",
      "glass-border": "#fbf1c71a",
      "find-match": "#83a59866",
      "find-match-current": "#aea85166",
      "accent-soft-solid": "#3a3c3a",
      "success-soft-solid": "#42412e",
      "warning-soft-solid": "#4a412f",
      "danger-soft-solid": "#4a3330",
      "on-cta": "#32302f",
      "glass-tint": "#32302fc7"
    },
    "syntax": {
      "keyword": "#fb4833",
      "string": "#b8bb25",
      "number": "#d3869b",
      "comment": "#a89984",
      "variable": "#ebdbb2",
      "property": "#ebdbb2",
      "function": "#b8bb25",
      "type": "#fabd2e",
      "tag": "#8ec07c",
      "heading": "#b8bb25",
      "punctuation": "#d5c4a1",
      "operator": "#8ec07c",
      "link": "#d3869b"
    },
    "ansi": [
      "#282828",
      "#cc241d",
      "#98971a",
      "#d79921",
      "#458588",
      "#b16286",
      "#689d6a",
      "#a89984",
      "#928374",
      "#fb4934",
      "#b8bb26",
      "#fabd2f",
      "#83a598",
      "#d3869b",
      "#8ec07c",
      "#fbf1c7"
    ]
  },
  {
    "id": "gruvbox-light",
    "name": "Gruvbox Light",
    "family": "Gruvbox",
    "author": "Zed Industries",
    "appearance": "light",
    "colors": {
      "surface-1": "#fbf1c7",
      "surface-0": "#ecddb4",
      "sidebar-surface": "#ecddb4",
      "text-primary": "#282828",
      "text-secondary": "#5f5650",
      "text-tertiary": "#897b6e",
      "surface-2": "#dccfa9",
      "surface-3": "#d3c5a2",
      "border-subtle": "#ddcca7",
      "border-strong": "#c8b899",
      "accent": "#0b6678",
      "accent-hover": "#095766",
      "on-accent": "#fbf1c7",
      "accent-soft": "#0b667814",
      "focus-ring": "#0b66784d",
      "success": "#797410",
      "success-soft": "#7974101a",
      "warning": "#b57615",
      "warning-soft": "#b576151a",
      "danger": "#9d0308",
      "danger-soft": "#9d03081a",
      "primary-fill": "#282828",
      "primary-label": "#fbf1c7",
      "glass-fill": "#ecddb4d6",
      "glass-border": "#2828281a",
      "find-match": "#0b667866",
      "find-match-current": "#ba2d1166",
      "accent-soft-solid": "#e8e6c1",
      "success-soft-solid": "#eee5b5",
      "warning-soft-solid": "#f4e5b5",
      "danger-soft-solid": "#f2d9b4",
      "on-cta": "#fbf1c7",
      "glass-tint": "#fbf1c7c7"
    },
    "syntax": {
      "keyword": "#9d0006",
      "string": "#79740e",
      "number": "#8f3e71",
      "comment": "#7c6f64",
      "variable": "#282828",
      "property": "#282828",
      "function": "#79740e",
      "type": "#b57613",
      "tag": "#427b58",
      "heading": "#79740e",
      "punctuation": "#3c3836",
      "operator": "#427b58",
      "link": "#8f3e71"
    },
    "ansi": [
      "#fbf1c7",
      "#cc241d",
      "#98971a",
      "#d79921",
      "#458588",
      "#b16286",
      "#689d6a",
      "#7c6f64",
      "#928374",
      "#9d0006",
      "#79740e",
      "#b57614",
      "#076678",
      "#8f3f71",
      "#427b58",
      "#282828"
    ]
  },
  {
    "id": "gruvbox-light-hard",
    "name": "Gruvbox Light Hard",
    "family": "Gruvbox",
    "author": "Zed Industries",
    "appearance": "light",
    "colors": {
      "surface-1": "#f9f5d7",
      "surface-0": "#ecddb5",
      "sidebar-surface": "#ecddb5",
      "text-primary": "#282828",
      "text-secondary": "#5f5650",
      "text-tertiary": "#897b6e",
      "surface-2": "#dccfaa",
      "surface-3": "#d3c5a3",
      "border-subtle": "#ddcca7",
      "border-strong": "#c8b899",
      "accent": "#0b6678",
      "accent-hover": "#095766",
      "on-accent": "#f9f5d7",
      "accent-soft": "#0b667814",
      "focus-ring": "#0b66784d",
      "success": "#797410",
      "success-soft": "#7974101a",
      "warning": "#b57615",
      "warning-soft": "#b576151a",
      "danger": "#9d0308",
      "danger-soft": "#9d03081a",
      "primary-fill": "#282828",
      "primary-label": "#f9f5d7",
      "glass-fill": "#ecddb5d6",
      "glass-border": "#2828281a",
      "find-match": "#0b667866",
      "find-match-current": "#dc351466",
      "accent-soft-solid": "#e6eacf",
      "success-soft-solid": "#ece8c3",
      "warning-soft-solid": "#f2e8c4",
      "danger-soft-solid": "#f0ddc2",
      "on-cta": "#f9f5d7",
      "glass-tint": "#f9f5d7c7"
    },
    "syntax": {
      "keyword": "#9d0006",
      "string": "#79740e",
      "number": "#8f3e71",
      "comment": "#7c6f64",
      "variable": "#282828",
      "property": "#282828",
      "function": "#79740e",
      "type": "#b57613",
      "tag": "#427b58",
      "heading": "#79740e",
      "punctuation": "#3c3836",
      "operator": "#427b58",
      "link": "#8f3e71"
    },
    "ansi": [
      "#fbf1c7",
      "#cc241d",
      "#98971a",
      "#d79921",
      "#458588",
      "#b16286",
      "#689d6a",
      "#7c6f64",
      "#928374",
      "#9d0006",
      "#79740e",
      "#b57614",
      "#076678",
      "#8f3f71",
      "#427b58",
      "#282828"
    ]
  },
  {
    "id": "gruvbox-light-soft",
    "name": "Gruvbox Light Soft",
    "family": "Gruvbox",
    "author": "Zed Industries",
    "appearance": "light",
    "colors": {
      "surface-1": "#f2e5bc",
      "surface-0": "#ecdcb3",
      "sidebar-surface": "#ecdcb3",
      "text-primary": "#282828",
      "text-secondary": "#5f5650",
      "text-tertiary": "#897b6e",
      "surface-2": "#dccea8",
      "surface-3": "#d3c5a1",
      "border-subtle": "#ddcca7",
      "border-strong": "#c8b899",
      "accent": "#0b6678",
      "accent-hover": "#095766",
      "on-accent": "#f2e5bc",
      "accent-soft": "#0b667814",
      "focus-ring": "#0b66784d",
      "success": "#797410",
      "success-soft": "#7974101a",
      "warning": "#b57615",
      "warning-soft": "#b576151a",
      "danger": "#9d0308",
      "danger-soft": "#9d03081a",
      "primary-fill": "#282828",
      "primary-label": "#f2e5bc",
      "glass-fill": "#ecdcb3d6",
      "glass-border": "#2828281a",
      "find-match": "#0b667866",
      "find-match-current": "#d7331466",
      "accent-soft-solid": "#e0dbb7",
      "success-soft-solid": "#e6daab",
      "warning-soft-solid": "#ecdaab",
      "danger-soft-solid": "#eaceaa",
      "on-cta": "#f2e5bc",
      "glass-tint": "#f2e5bcc7"
    },
    "syntax": {
      "keyword": "#9d0006",
      "string": "#79740e",
      "number": "#8f3e71",
      "comment": "#7c6f64",
      "variable": "#282828",
      "property": "#282828",
      "function": "#79740e",
      "type": "#b57613",
      "tag": "#427b58",
      "heading": "#79740e",
      "punctuation": "#3c3836",
      "operator": "#427b58",
      "link": "#8f3e71"
    },
    "ansi": [
      "#fbf1c7",
      "#cc241d",
      "#98971a",
      "#d79921",
      "#458588",
      "#b16286",
      "#689d6a",
      "#7c6f64",
      "#928374",
      "#9d0006",
      "#79740e",
      "#b57614",
      "#076678",
      "#8f3f71",
      "#427b58",
      "#282828"
    ]
  },
  {
    "id": "nord-dark",
    "name": "Nord Dark",
    "family": "Nord",
    "author": "Sergei <Mikasius> Metlenkin",
    "appearance": "dark",
    "colors": {
      "surface-1": "#2e3440",
      "surface-0": "#2e3440",
      "sidebar-surface": "#2e3440",
      "text-primary": "#eceff4",
      "text-secondary": "#d8dee9",
      "text-tertiary": "#777d89",
      "surface-2": "#353b46",
      "surface-3": "#3c424e",
      "border-subtle": "#4b5262",
      "border-strong": "#3b4252",
      "accent": "#88c0d0",
      "accent-hover": "#a0cdd9",
      "on-accent": "#2e3440",
      "accent-soft": "#88c0d01a",
      "focus-ring": "#88c0d04d",
      "success": "#a3be8c",
      "success-soft": "#a3be8c1f",
      "warning": "#ebcb8b",
      "warning-soft": "#ebcb8b1f",
      "danger": "#bf616a",
      "danger-soft": "#bf616a1f",
      "primary-fill": "#eceff4",
      "primary-label": "#2e3440",
      "glass-fill": "#2e3440c7",
      "glass-border": "#eceff41a",
      "find-match": "#88c0d033",
      "find-match-current": "#ebcb8b99",
      "accent-soft-solid": "#37424e",
      "success-soft-solid": "#3c4549",
      "warning-soft-solid": "#454649",
      "danger-soft-solid": "#3f3945",
      "on-cta": "#2e3440",
      "glass-tint": "#2e3440c7"
    },
    "syntax": {
      "keyword": "#81a1c1",
      "string": "#a3be8c",
      "number": "#b48ead",
      "comment": "#4c566a",
      "variable": "#d8dee9",
      "property": "#88c0d0",
      "function": "#88c0d0",
      "type": "#8fbcbb",
      "tag": "#81a1c1",
      "heading": "#81a1c1",
      "punctuation": "#eceff4",
      "operator": "#81a1c1",
      "link": "#88c0d0"
    },
    "ansi": [
      "#3b4252",
      "#bf616a",
      "#a3be8c",
      "#ebcb8b",
      "#81a1c1",
      "#b48ead",
      "#6c99a6",
      "#e5e9f0",
      "#4c566a",
      "#bf616a",
      "#a3be8c",
      "#ebcb8b",
      "#81a1c1",
      "#b48ead",
      "#8fbcbb",
      "#eceff4"
    ]
  },
  {
    "id": "nord-darker",
    "name": "Nord Darker",
    "family": "Nord",
    "author": "Sergei <Mikasius> Metlenkin",
    "appearance": "dark",
    "colors": {
      "surface-1": "#191c29",
      "surface-0": "#191c29",
      "sidebar-surface": "#191c29",
      "text-primary": "#eceff4",
      "text-secondary": "#d8dee9",
      "text-tertiary": "#656a76",
      "surface-2": "#202330",
      "surface-3": "#292c38",
      "border-subtle": "#4b5262",
      "border-strong": "#3b4252",
      "accent": "#88c0d0",
      "accent-hover": "#a0cdd9",
      "on-accent": "#191c29",
      "accent-soft": "#88c0d01a",
      "focus-ring": "#88c0d04d",
      "success": "#a3be8c",
      "success-soft": "#a3be8c1f",
      "warning": "#ebcb8b",
      "warning-soft": "#ebcb8b1f",
      "danger": "#bf616a",
      "danger-soft": "#bf616a1f",
      "primary-fill": "#eceff4",
      "primary-label": "#191c29",
      "glass-fill": "#191c29c7",
      "glass-border": "#eceff41a",
      "find-match": "#88c0d033",
      "find-match-current": "#ebcb8b99",
      "accent-soft-solid": "#242c3a",
      "success-soft-solid": "#2a2f35",
      "warning-soft-solid": "#323135",
      "danger-soft-solid": "#2d2431",
      "on-cta": "#191c29",
      "glass-tint": "#191c29c7"
    },
    "syntax": {
      "keyword": "#81a1c1",
      "string": "#a3be8c",
      "number": "#b48ead",
      "comment": "#afb8c7",
      "variable": "#d8dee9",
      "property": "#88c0d0",
      "function": "#88c0d0",
      "type": "#8fbcbb",
      "tag": "#81a1c1",
      "heading": "#81a1c1",
      "punctuation": "#eceff4",
      "operator": "#81a1c1",
      "link": "#88c0d0"
    },
    "ansi": [
      "#3b4252",
      "#bf616a",
      "#a3be8c",
      "#ebcb8b",
      "#81a1c1",
      "#b48ead",
      "#6c99a6",
      "#e5e9f0",
      "#4c566a",
      "#bf616a",
      "#a3be8c",
      "#ebcb8b",
      "#81a1c1",
      "#b48ead",
      "#8fbcbb",
      "#eceff4"
    ]
  },
  {
    "id": "nord-light",
    "name": "Nord Light",
    "family": "Nord",
    "author": "Sergei <Mikasius> Metlenkin",
    "appearance": "light",
    "colors": {
      "surface-1": "#eceff4",
      "surface-0": "#f6f8fa",
      "sidebar-surface": "#f6f8fa",
      "text-primary": "#444d56",
      "text-secondary": "#646d77",
      "text-tertiary": "#838a93",
      "surface-2": "#dfe2e7",
      "surface-3": "#d6dadf",
      "border-subtle": "#e1e4e8",
      "border-strong": "#e1e4e8",
      "accent": "#2188ff",
      "accent-hover": "#1c74d9",
      "on-accent": "#eceff4",
      "accent-soft": "#2188ff14",
      "focus-ring": "#2188ff4d",
      "success": "#28a745",
      "success-soft": "#28a7451a",
      "warning": "#bfa76b",
      "warning-soft": "#bfa76b1a",
      "danger": "#d73a49",
      "danger-soft": "#d73a491a",
      "primary-fill": "#444d56",
      "primary-label": "#eceff4",
      "glass-fill": "#f6f8fad6",
      "glass-border": "#444d561a",
      "find-match": "#bfa76b59",
      "find-match-current": "#bfa76b99",
      "accent-soft-solid": "#dce7f5",
      "success-soft-solid": "#d8e8e3",
      "warning-soft-solid": "#e8e8e6",
      "danger-soft-solid": "#eadde3",
      "on-cta": "#eceff4",
      "glass-tint": "#eceff4c7"
    },
    "syntax": {
      "keyword": "#d73a49",
      "string": "#032f62",
      "number": "#3b4252",
      "comment": "#6a737d",
      "variable": "#3b4252",
      "property": "#3b4252",
      "function": "#2188ff",
      "type": "#0d7579",
      "tag": "#0d7579",
      "heading": "#509546",
      "punctuation": "#646d77",
      "operator": "#cb5c69",
      "link": "#cb5c69"
    },
    "ansi": [
      "#dfe2e7",
      "#d73a49",
      "#28a745",
      "#bfa76b",
      "#2188ff",
      "#d73a49",
      "#2598a2",
      "#646d77",
      "#838a93",
      "#ac2e3a",
      "#208637",
      "#bfa76b",
      "#1a6dcc",
      "#ac2e3a",
      "#1d7982",
      "#444d56"
    ]
  },
  {
    "id": "one-dark",
    "name": "One Dark",
    "family": "One",
    "author": "Zed Industries",
    "appearance": "dark",
    "colors": {
      "surface-1": "#282c33",
      "surface-0": "#2f343e",
      "sidebar-surface": "#2f343e",
      "text-primary": "#dce0e5",
      "text-secondary": "#a9afbc",
      "text-tertiary": "#878a98",
      "surface-2": "#353a44",
      "surface-3": "#3c414b",
      "border-subtle": "#363c46",
      "border-strong": "#464b57",
      "accent": "#74ade8",
      "accent-hover": "#90bded",
      "on-accent": "#282c33",
      "accent-soft": "#74ade81a",
      "focus-ring": "#74ade84d",
      "success": "#a1c181",
      "success-soft": "#a1c1811f",
      "warning": "#dec184",
      "warning-soft": "#dec1841f",
      "danger": "#d07277",
      "danger-soft": "#d072771f",
      "primary-fill": "#dce0e5",
      "primary-label": "#282c33",
      "glass-fill": "#2f343ec7",
      "glass-border": "#dce0e51a",
      "find-match": "#74ade866",
      "find-match-current": "#e8af7466",
      "accent-soft-solid": "#303945",
      "success-soft-solid": "#373e3c",
      "warning-soft-solid": "#3e3e3d",
      "danger-soft-solid": "#3c343b",
      "on-cta": "#282c33",
      "glass-tint": "#282c33c7"
    },
    "syntax": {
      "keyword": "#b477cf",
      "string": "#a1c181",
      "number": "#bf956a",
      "comment": "#5d636f",
      "variable": "#acb2be",
      "property": "#d07277",
      "function": "#73ade9",
      "type": "#6eb4bf",
      "tag": "#74ade8",
      "heading": "#d07277",
      "punctuation": "#acb2be",
      "operator": "#6eb4bf",
      "link": "#6eb4bf"
    },
    "ansi": [
      "#282c34",
      "#e06c75",
      "#98c379",
      "#e5c07b",
      "#61afef",
      "#c678dd",
      "#56b6c2",
      "#abb2bf",
      "#636d83",
      "#ea858b",
      "#aad581",
      "#ffd885",
      "#85c1ff",
      "#d398eb",
      "#6ed5de",
      "#fafafa"
    ]
  },
  {
    "id": "one-light",
    "name": "One Light",
    "family": "One",
    "author": "Zed Industries",
    "appearance": "light",
    "colors": {
      "surface-1": "#fafafa",
      "surface-0": "#ebebec",
      "sidebar-surface": "#ebebec",
      "text-primary": "#242529",
      "text-secondary": "#58585a",
      "text-tertiary": "#7e8086",
      "surface-2": "#dbdbdc",
      "surface-3": "#d1d1d3",
      "border-subtle": "#dfdfe0",
      "border-strong": "#c9c9ca",
      "accent": "#5c78e2",
      "accent-hover": "#4e66c0",
      "on-accent": "#fafafa",
      "accent-soft": "#5c78e214",
      "focus-ring": "#5c78e24d",
      "success": "#669f59",
      "success-soft": "#669f591a",
      "warning": "#a48819",
      "warning-soft": "#a488191a",
      "danger": "#d36151",
      "danger-soft": "#d361511a",
      "primary-fill": "#242529",
      "primary-label": "#fafafa",
      "glass-fill": "#ebebecd6",
      "glass-border": "#2425291a",
      "find-match": "#5c79e266",
      "find-match-current": "#d0a92366",
      "accent-soft-solid": "#edf0f8",
      "success-soft-solid": "#ebf1ea",
      "warning-soft-solid": "#f1efe4",
      "danger-soft-solid": "#f6ebe9",
      "on-cta": "#fafafa",
      "glass-tint": "#fafafac7"
    },
    "syntax": {
      "keyword": "#a449ab",
      "string": "#649f57",
      "number": "#ad6e25",
      "comment": "#a2a3a7",
      "variable": "#242529",
      "property": "#d3604f",
      "function": "#5b79e3",
      "type": "#3882b7",
      "tag": "#5c78e2",
      "heading": "#d3604f",
      "punctuation": "#242529",
      "operator": "#3882b7",
      "link": "#3882b7"
    },
    "ansi": [
      "#000000",
      "#de3e35",
      "#3f953a",
      "#d2b67c",
      "#2f5af3",
      "#950095",
      "#0997b3",
      "#bbbbbb",
      "#000000",
      "#de3e35",
      "#3f953a",
      "#d2b67c",
      "#2f5af3",
      "#a00095",
      "#0bbcd6",
      "#ffffff"
    ]
  },
  {
    "id": "rose-pine",
    "name": "Rosé Pine",
    "family": "Rosé Pine",
    "author": "Kainoa Kanter <kainoa@t1c.dev>",
    "appearance": "dark",
    "colors": {
      "surface-1": "#191724",
      "surface-0": "#191724",
      "sidebar-surface": "#191724",
      "text-primary": "#e0def4",
      "text-secondary": "#908caa",
      "text-tertiary": "#6e6a86",
      "surface-2": "#201e2b",
      "surface-3": "#282634",
      "border-subtle": "#524f67",
      "border-strong": "#403d52",
      "accent": "#9ccfd8",
      "accent-hover": "#b0d9e0",
      "on-accent": "#191724",
      "accent-soft": "#9ccfd81a",
      "focus-ring": "#9ccfd84d",
      "success": "#31748f",
      "success-soft": "#31748f1f",
      "warning": "#f6c177",
      "warning-soft": "#f6c1771f",
      "danger": "#eb6f92",
      "danger-soft": "#eb6f921f",
      "primary-fill": "#e0def4",
      "primary-label": "#191724",
      "glass-fill": "#191724c7",
      "glass-border": "#e0def41a",
      "find-match": "#f6c1774d",
      "find-match-current": "#f6c17780",
      "accent-soft-solid": "#262936",
      "success-soft-solid": "#1c2231",
      "warning-soft-solid": "#342b2e",
      "danger-soft-solid": "#322231",
      "on-cta": "#191724",
      "glass-tint": "#191724c7"
    },
    "syntax": {
      "keyword": "#31748f",
      "string": "#f6c177",
      "number": "#ebbcba",
      "comment": "#6e6a86",
      "variable": "#e0def4",
      "property": "#c4a7e7",
      "function": "#ebbcba",
      "type": "#9ccfd8",
      "tag": "#9ccfd8",
      "heading": "#eb6f92",
      "punctuation": "#908caa",
      "operator": "#908caa",
      "link": "#31748f"
    },
    "ansi": [
      "#21202e",
      "#eb6f92",
      "#31748f",
      "#f6c177",
      "#9ccfd8",
      "#c4a7e7",
      "#ebbcba",
      "#e0def4",
      "#908caa",
      "#eb6f92",
      "#31748f",
      "#f6c177",
      "#9ccfd8",
      "#c4a7e7",
      "#ebbcba",
      "#e0def4"
    ]
  },
  {
    "id": "rose-pine-moon",
    "name": "Rosé Pine Moon",
    "family": "Rosé Pine",
    "author": "Kainoa Kanter <kainoa@t1c.dev>",
    "appearance": "dark",
    "colors": {
      "surface-1": "#232136",
      "surface-0": "#232136",
      "sidebar-surface": "#232136",
      "text-primary": "#e0def4",
      "text-secondary": "#908caa",
      "text-tertiary": "#6e6a86",
      "surface-2": "#2a283d",
      "surface-3": "#312f44",
      "border-subtle": "#56526e",
      "border-strong": "#44415a",
      "accent": "#9ccfd8",
      "accent-hover": "#b0d9e0",
      "on-accent": "#232136",
      "accent-soft": "#9ccfd81a",
      "focus-ring": "#9ccfd84d",
      "success": "#3e8fb0",
      "success-soft": "#3e8fb01f",
      "warning": "#f6c177",
      "warning-soft": "#f6c1771f",
      "danger": "#eb6f92",
      "danger-soft": "#eb6f921f",
      "primary-fill": "#e0def4",
      "primary-label": "#232136",
      "glass-fill": "#232136c7",
      "glass-border": "#e0def41a",
      "find-match": "#f6c1774d",
      "find-match-current": "#f6c17780",
      "accent-soft-solid": "#2f3246",
      "success-soft-solid": "#262e45",
      "warning-soft-solid": "#3c343e",
      "danger-soft-solid": "#3b2a41",
      "on-cta": "#232136",
      "glass-tint": "#232136c7"
    },
    "syntax": {
      "keyword": "#3e8fb0",
      "string": "#f6c177",
      "number": "#ea9a97",
      "comment": "#6e6a86",
      "variable": "#e0def4",
      "property": "#c4a7e7",
      "function": "#ea9a97",
      "type": "#9ccfd8",
      "tag": "#9ccfd8",
      "heading": "#eb6f92",
      "punctuation": "#908caa",
      "operator": "#908caa",
      "link": "#3e8fb0"
    },
    "ansi": [
      "#2a283e",
      "#eb6f92",
      "#3e8fb0",
      "#f6c177",
      "#9ccfd8",
      "#c4a7e7",
      "#ea9a97",
      "#e0def4",
      "#908caa",
      "#eb6f92",
      "#3e8fb0",
      "#f6c177",
      "#9ccfd8",
      "#c4a7e7",
      "#ea9a97",
      "#e0def4"
    ]
  },
  {
    "id": "rose-pine-dawn",
    "name": "Rosé Pine Dawn",
    "family": "Rosé Pine",
    "author": "Kainoa Kanter <kainoa@t1c.dev>",
    "appearance": "light",
    "colors": {
      "surface-1": "#faf4ed",
      "surface-0": "#faf4ed",
      "sidebar-surface": "#faf4ed",
      "text-primary": "#575279",
      "text-secondary": "#716c8d",
      "text-tertiary": "#908ba0",
      "surface-2": "#ede7e4",
      "surface-3": "#e5dfde",
      "border-subtle": "#cecacd",
      "border-strong": "#dfdad9",
      "accent": "#56949f",
      "accent-hover": "#497e87",
      "on-accent": "#faf4ed",
      "accent-soft": "#56949f14",
      "focus-ring": "#56949f4d",
      "success": "#286983",
      "success-soft": "#2869831a",
      "warning": "#ea9d34",
      "warning-soft": "#ea9d341a",
      "danger": "#b4637a",
      "danger-soft": "#b4637a1a",
      "primary-fill": "#575279",
      "primary-label": "#faf4ed",
      "glass-fill": "#faf4edd6",
      "glass-border": "#5752791a",
      "find-match": "#ea9d344d",
      "find-match-current": "#ea9d3480",
      "accent-soft-solid": "#edece7",
      "success-soft-solid": "#e5e6e2",
      "warning-soft-solid": "#f8ebdb",
      "danger-soft-solid": "#f3e6e2",
      "on-cta": "#faf4ed",
      "glass-tint": "#faf4edc7"
    },
    "syntax": {
      "keyword": "#286983",
      "string": "#ea9d34",
      "number": "#d7827e",
      "comment": "#9893a5",
      "variable": "#575279",
      "property": "#907aa9",
      "function": "#d7827e",
      "type": "#56949f",
      "tag": "#56949f",
      "heading": "#b4637a",
      "punctuation": "#797593",
      "operator": "#797593",
      "link": "#286983"
    },
    "ansi": [
      "#f4ede8",
      "#b4637a",
      "#286983",
      "#ea9d34",
      "#56949f",
      "#907aa9",
      "#d7827e",
      "#575279",
      "#797593",
      "#b4637a",
      "#286983",
      "#ea9d34",
      "#56949f",
      "#907aa9",
      "#d7827e",
      "#575279"
    ]
  },
  {
    "id": "tokyo-night",
    "name": "Tokyo Night",
    "family": "Tokyo Night",
    "author": "Tokyo Night: Zed Theme Importer",
    "appearance": "dark",
    "colors": {
      "surface-1": "#1a1b26",
      "surface-0": "#16161e",
      "sidebar-surface": "#16161e",
      "text-primary": "#a9b1d6",
      "text-secondary": "#7f84a2",
      "text-tertiary": "#787c99",
      "surface-2": "#1f202c",
      "surface-3": "#252633",
      "border-subtle": "#101014",
      "border-strong": "#101014",
      "accent": "#7dcfff",
      "accent-hover": "#97d9ff",
      "on-accent": "#1a1b26",
      "accent-soft": "#7dcfff1a",
      "focus-ring": "#7dcfff4d",
      "success": "#9ece6a",
      "success-soft": "#9ece6a1f",
      "warning": "#e0af68",
      "warning-soft": "#e0af681f",
      "danger": "#f7768e",
      "danger-soft": "#f7768e1f",
      "primary-fill": "#a9b1d6",
      "primary-label": "#1a1b26",
      "glass-fill": "#16161ec7",
      "glass-border": "#a9b1d61a",
      "find-match": "#414868",
      "find-match-current": "#e0af6899",
      "accent-soft-solid": "#242d3c",
      "success-soft-solid": "#2a302e",
      "warning-soft-solid": "#322d2e",
      "danger-soft-solid": "#352632",
      "on-cta": "#1a1b26",
      "glass-tint": "#1a1b26c7"
    },
    "syntax": {
      "keyword": "#bb9af7",
      "string": "#9ece6a",
      "number": "#ff9e64",
      "comment": "#51597d",
      "variable": "#c0caf5",
      "property": "#c0caf5",
      "function": "#7aa2f7",
      "type": "#0db9d7",
      "tag": "#f7768e",
      "heading": "#ff9e64",
      "punctuation": "#89ddff",
      "operator": "#89ddff",
      "link": "#73daca"
    },
    "ansi": [
      "#363b54",
      "#f7768e",
      "#73daca",
      "#e0af68",
      "#7aa2f7",
      "#bb9af7",
      "#7dcfff",
      "#787c99",
      "#363b54",
      "#f7768e",
      "#41a6b5",
      "#e0af68",
      "#7aa2f7",
      "#bb9af7",
      "#7dcfff",
      "#acb0d0"
    ]
  },
  {
    "id": "tokyo-night-light",
    "name": "Tokyo Night Light",
    "family": "Tokyo Night",
    "author": "Tokyo Night: Zed Theme Importer",
    "appearance": "light",
    "colors": {
      "surface-1": "#d5d6db",
      "surface-0": "#cbccd1",
      "sidebar-surface": "#cbccd1",
      "text-primary": "#343b58",
      "text-secondary": "#4c505e",
      "text-tertiary": "#4c505e",
      "surface-2": "#bfc0c7",
      "surface-3": "#b7b9c1",
      "border-subtle": "#c1c2c7",
      "border-strong": "#c1c2c7",
      "accent": "#0f4b6e",
      "accent-hover": "#0d405e",
      "on-accent": "#d5d6db",
      "accent-soft": "#0f4b6e14",
      "focus-ring": "#0f4b6e4d",
      "success": "#485e30",
      "success-soft": "#485e301a",
      "warning": "#8f5e15",
      "warning-soft": "#8f5e151a",
      "danger": "#8c4351",
      "danger-soft": "#8c43511a",
      "primary-fill": "#343b58",
      "primary-label": "#d5d6db",
      "glass-fill": "#cbccd1d6",
      "glass-border": "#343b581a",
      "find-match": "#9699a3",
      "find-match-current": "#8f5e1599",
      "accent-soft-solid": "#c5cbd2",
      "success-soft-solid": "#c7caca",
      "warning-soft-solid": "#cecac7",
      "danger-soft-solid": "#cec7cd",
      "on-cta": "#d5d6db",
      "glass-tint": "#d5d6dbc7"
    },
    "syntax": {
      "keyword": "#5a4a78",
      "string": "#485e30",
      "number": "#965027",
      "comment": "#9699a3",
      "variable": "#343b58",
      "property": "#343b58",
      "function": "#34548a",
      "type": "#166775",
      "tag": "#8c4351",
      "heading": "#965027",
      "punctuation": "#4c505e",
      "operator": "#4c505e",
      "link": "#33635c"
    },
    "ansi": [
      "#0f0f14",
      "#8c4351",
      "#33635c",
      "#8f5e15",
      "#34548a",
      "#5a4a78",
      "#0f4b6e",
      "#828594",
      "#0f0f14",
      "#8c4351",
      "#33635c",
      "#8f5e15",
      "#34548a",
      "#5a4a78",
      "#0f4b6e",
      "#828594"
    ]
  },
  {
    "id": "tokyo-night-storm",
    "name": "Tokyo Night Storm",
    "family": "Tokyo Night",
    "author": "Tokyo Night: Zed Theme Importer",
    "appearance": "dark",
    "colors": {
      "surface-1": "#24283b",
      "surface-0": "#1f2335",
      "sidebar-surface": "#1f2335",
      "text-primary": "#a9b1d6",
      "text-secondary": "#858eb4",
      "text-tertiary": "#787c99",
      "surface-2": "#292d40",
      "surface-3": "#2e3247",
      "border-subtle": "#1b1e2e",
      "border-strong": "#1b1e2e",
      "accent": "#7dcfff",
      "accent-hover": "#97d9ff",
      "on-accent": "#24283b",
      "accent-soft": "#7dcfff1a",
      "focus-ring": "#7dcfff4d",
      "success": "#9ece6a",
      "success-soft": "#9ece6a1f",
      "warning": "#e0af68",
      "warning-soft": "#e0af681f",
      "danger": "#f7768e",
      "danger-soft": "#f7768e1f",
      "primary-fill": "#a9b1d6",
      "primary-label": "#24283b",
      "glass-fill": "#1f2335c7",
      "glass-border": "#a9b1d61a",
      "find-match": "#414868",
      "find-match-current": "#e0af6899",
      "accent-soft-solid": "#2d394f",
      "success-soft-solid": "#333c41",
      "warning-soft-solid": "#3b3840",
      "danger-soft-solid": "#3d3145",
      "on-cta": "#24283b",
      "glass-tint": "#24283bc7"
    },
    "syntax": {
      "keyword": "#bb9af7",
      "string": "#9ece6a",
      "number": "#ff9e64",
      "comment": "#5f6996",
      "variable": "#c0caf5",
      "property": "#c0caf5",
      "function": "#7aa2f7",
      "type": "#2ac3de",
      "tag": "#f7768e",
      "heading": "#ff9e64",
      "punctuation": "#89ddff",
      "operator": "#89ddff",
      "link": "#73daca"
    },
    "ansi": [
      "#414868",
      "#f7768e",
      "#73daca",
      "#e0af68",
      "#7aa2f7",
      "#bb9af7",
      "#7dcfff",
      "#7982a9",
      "#414868",
      "#f7768e",
      "#73daca",
      "#e0af68",
      "#7aa2f7",
      "#bb9af7",
      "#7dcfff",
      "#a9b1d6"
    ]
  },
  {
    "id": "tokyo-night-moon",
    "name": "Tokyo Night Moon",
    "family": "Tokyo Night",
    "author": "Tokyo Night: Zed Theme Importer",
    "appearance": "dark",
    "colors": {
      "surface-1": "#222436",
      "surface-0": "#1e2030",
      "sidebar-surface": "#1e2030",
      "text-primary": "#828bb8",
      "text-secondary": "#818ab6",
      "text-tertiary": "#787c99",
      "surface-2": "#25283b",
      "surface-3": "#292c40",
      "border-subtle": "#1b1e2e",
      "border-strong": "#1b1e2e",
      "accent": "#86e1fc",
      "accent-hover": "#9ee7fd",
      "on-accent": "#222436",
      "accent-soft": "#86e1fc1a",
      "focus-ring": "#86e1fc4d",
      "success": "#c3e88d",
      "success-soft": "#c3e88d1f",
      "warning": "#ffc777",
      "warning-soft": "#ffc7771f",
      "danger": "#ff757f",
      "danger-soft": "#ff757f1f",
      "primary-fill": "#828bb8",
      "primary-label": "#222436",
      "glass-fill": "#1e2030c7",
      "glass-border": "#828bb81a",
      "find-match": "#444a73",
      "find-match-current": "#ffc77799",
      "accent-soft-solid": "#2c374a",
      "success-soft-solid": "#353c40",
      "warning-soft-solid": "#3d383e",
      "danger-soft-solid": "#3d2e3f",
      "on-cta": "#222436",
      "glass-tint": "#222436c7"
    },
    "syntax": {
      "keyword": "#c099ff",
      "string": "#c3e88d",
      "number": "#ff966c",
      "comment": "#636da6",
      "variable": "#c8d3f5",
      "property": "#c8d3f5",
      "function": "#82aaff",
      "type": "#65bcff",
      "tag": "#ff757f",
      "heading": "#ff966c",
      "punctuation": "#89ddff",
      "operator": "#89ddff",
      "link": "#4fd6be"
    },
    "ansi": [
      "#444a73",
      "#ff757f",
      "#4fd6be",
      "#ffc777",
      "#82aaff",
      "#c099ff",
      "#86e1fc",
      "#7982a9",
      "#444a73",
      "#ff757f",
      "#4fd6be",
      "#ffc777",
      "#82aaff",
      "#c099ff",
      "#86e1fc",
      "#828bb8"
    ]
  }
];
